<template>
  <CDialog v-bind="{ show }" no-header body-class="!max-w-[421px]">
    <div class="p-5">
      <CRoundedIcon
        class="!text-4.5xl"
        color="!text-green bg-green-100"
        icon="icon-filled-tick-circle"
      />
      <p
        class="text-center mt-5 text-xl leading-130 font-semibold text-dark-100"
      >
        {{ $t("want_sell_title") }}
      </p>
      <i18n-t
        keypath="want_sell_desc"
        tag="p"
        class="text-base leading-130 font-normal text-gray-700 text-center mt-2 mx-auto"
      >
        <template #coin>{{ pair }}</template>
      </i18n-t>
      <div
        class="border border-yellow/80 p-2 rounded-xl bg-yellow-100 mt-2 text-center"
      >
        <span class="text-sm leading-110 text-dark-200">{{
          $t("sell_bot_info")
        }}</span>
      </div>
      <div class="mt-7 flex-y-center gap-4">
        <CButton
          variant="info"
          class="w-full"
          @click="$emit('close')"
          :text="$t('cancel')"
        />
        <CButton
          variant="success_info"
          class="w-full"
          :text="$t('sell')"
          @click="$emit('submit')"
          :loading="loading"
        />
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CRoundedIcon from "@/components/Common/CRoundedIcon.vue";
import CButton from "@/components/Common/CButton.vue";

interface Props {
  loading?: boolean;
  show?: boolean;
  pair: string;
}
defineProps<Props>();

defineEmits<{
  (e: "fetchData"): void;
  (e: "close"): void;
  (e: "submit"): void;
}>();
</script>
